import { getDomain } from "./helpers.js";
import axios from "axios";
import odata from "odata-client";

export async function loadOptions(type) {
    const url =
        getDomain() + `/odata/smlookup?$filter=contains(type, '${type}')`;

    const response = await axios.get(url);

    return response.data.value;
}

export default { loadOptions };
